import * as React from "react";

function Details() {
  return (
    <>
      <div
        id="Experience"
        className="details-container"
        data-aos="fade-right"
        data-aos-offset="400"
        data-aos-easing="ease-in-out"
        data-aos-duration="1000"
      >
        <h1 className="mx-3 my-0 mt-4">
          Work Experience <i class="fas fa-briefcase"></i>
        </h1>
        <ul>
          <div className="details-div text-right">
            <li>
              <h4>Accenture</h4>
              <h5>Application Development Analyst</h5>
              <h6>Mumbai - 2021-Present</h6>
              Worked on Client Application as "UI Developer" adding new
              features/screens, Maintaining & debugging the application using
              chrome developer tools.
              <br />
              Creating new functions using "JavaScript" as primary language and
              adding new styles using CSS, SCSS modules,
              <br />
              Also worked on migrating the client application into "React".
              built react functional components and solved defects
              <br />
              Used Rally for stories assignment and tracking daily activities,
              "Github Desktop" and "Jenkins" for code versioning/branching and
              code deployment.
            </li>
            <br />
            <li>
              <h4>Infosys Ltd.</h4>
              <h5>System Engineer</h5>
              <h6>Pune - 2018-2021</h6>
              Worked on project developments and enhancements using React, HTML,
              CSS and JavaScript, Nodejs Involved in initial
              <br />
              requirement and design phase, front end implementation. Proficient
              in writing javascript code with ES6 Features
              <br />
              Developed single page web applications using React Worked on API
              Calls to handle data from front-end components
              <br />
              Developed React apps with CRUD operation, Tracked defects/bugs in
              coordination with tech lead and developer.
            </li>
          </div>
        </ul>
      </div>
      <hr />
      <div
        id="Education"
        className="details-container"
        data-aos="fade-right"
        data-aos-offset="400"
        data-aos-duration="1000"
      >
        <h1 className="mx-3 my-0 mt-4">
          Education <i class="fas fa-graduation-cap"></i>
        </h1>
        <div className="row">
          <div className="details-div text-center col-md-4 col-sm-12">
            <div class="card h-100">
              <div class="card-body">
                <h4 class="card-title text-center">Sathaye College</h4>
                <h5>Bachelor in Information Technology</h5>
                <h6>Mumbai</h6>
                <h6>2015-2018</h6>
              </div>
            </div>
          </div>
          <div className="details-div text-center col-md-4 col-sm-12">
            <div class="card h-100">
              <div class="card-body">
                <h4 class="card-title text-center">R.D National College</h4>
                <h5>Higher Secondary Certificate (Science)</h5>
                <h6>Mumbai</h6>
                <h6>2013-2015</h6>
              </div>
            </div>
          </div>
        </div>
        <h1 className="mx-3 my-0 mt-4">
          Courses & Certifications <i class="fa fa-certificate"></i>{" "}
        </h1>
        <div className="row">
          <div className="certificates details-div text-center col-md-4 col-sm-12">
            <div
              onClick={() => {
                window.open(
                  "https://www.credly.com/badges/0b760f46-b5e8-4075-8d87-5062ad96d8d5?source=linked_in_profile"
                );
              }}
              class="card h-100"
            >
              <div class="card-body">
                <h4 class="card-title text-center">
                  AWS Certified Developer – Associate
                </h4>
                <h5>Amazon Web Services (AWS)</h5>
                <h6>Mar 2022</h6>
              </div>
            </div>
          </div>
          <div className="certificates details-div text-center col-md-4 col-sm-12">
            <div
              onClick={() => {
                window.open(
                  "https://www.coursera.org/account/accomplishments/certificate/PUM8XYC5429B"
                );
              }}
              class="card h-100"
            >
              <div class="card-body">
                <h4 class="card-title text-center">
                  Front-End Web Development with React
                </h4>
                <h5>Coursera</h5>
                <h6>May 2020</h6>
              </div>
            </div>
          </div>
          <div className="certificates details-div text-center col-md-4 col-sm-12">
            <div
              onClick={() => {
                window.open(
                  "https://www.coursera.org/account/accomplishments/certificate/RT7TZSGYJAK6"
                );
              }}
              class="card h-100"
            >
              <div class="card-body">
                <h4 class="card-title text-center">
                  Programming for Everybody (Getting Started with Python)
                </h4>
                <h5>Coursera</h5>
                <h6>May 2020</h6>
              </div>
            </div>
          </div>
          <div className="certificates details-div text-center col-md-4 col-sm-12">
            <div
              onClick={() => {
                window.open(
                  "https://analytics.google.com/analytics/academy/certificate/W9Bwx522SbqgHYO7LDv5rA"
                );
              }}
              class="card h-100"
            >
              <div class="card-body">
                <h4 class="card-title text-center">
                  Advanced Google Analytics
                </h4>
                <h5>Google</h5>
                <h6>May 2020</h6>
              </div>
            </div>
          </div>
          <div className="certificates details-div text-center col-md-4 col-sm-12">
            <div
              onClick={() => {
                window.open(
                  "https://drive.google.com/file/d/1Hfwz1_9hpsuW93qsTT_1uvGJbiI2oc9m/view?usp=sharing"
                );
              }}
              class="card h-100"
            >
              <div class="card-body">
                <h4 class="card-title text-center">
                  Angular Certificate of Training
                </h4>
                <h5>Internshala</h5>
                <h6>June 2020</h6>
              </div>
            </div>
          </div>
          <div className="certificates details-div text-center col-md-4 col-sm-12">
            <div
              onClick={() => {
                window.open("https://cutshort.io/certificate/35994");
              }}
              class="card h-100"
            >
              <div class="card-body">
                <h4 class="card-title text-center">
                  CutShort Certified React.js
                </h4>
                <h5>CutShort</h5>
                <h6>Feb 2021</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
    </>
  );
}

export default Details;
